import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { dailyScheduleSchema } from "../../schemas/dailyScheduleSchema";
import { addDailySchedule } from "../../../../api/scheduleApi";
import { FormControl } from "@mui/material";
import { MenuItem, InputLabel, Select } from "@mui/material";
import { TimeInput } from "../../../../common/components/Input";
import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
const AddDailyScheduleDialog = ({
  openAddDailySchedule,
  handleCloseAddDailySchedule,
  currentDailySchedule,
  fetchDailySchedule,
  handleOpenAlert,
  handleSetAlertMessage,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(dailyScheduleSchema),
  });

  const submitAddDailySchedule = async (values) => {
    const response = await addDailySchedule(values);
    if (response.data.error != null) {
      handleSetAlertMessage(response.data.error.message);
      handleOpenAlert();
    } else {
      handleCloseAddDailySchedule();
      fetchDailySchedule();
      reset();
    }
  };

  const minutesList = [
    {
      id: 0,
      timeSlotDurationMins: 30,
    },
    {
      id: 1,
      timeSlotDurationMins: 60,
    },
    {
      id: 3,
      timeSlotDurationMins: 90,
    },
    {
      id: 4,
      timeSlotDurationMins: 120,
    },
  ];

  return (
    <div>
      <StyledDialog
        open={openAddDailySchedule}
        onClose={handleCloseAddDailySchedule}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Add Daily Schedule</DialogTitle>
        <form onSubmit={handleSubmit(submitAddDailySchedule)}>
          <DialogContent dividers>
            <Grid container direction="column">
              <Grid item xs={8}>
                <FormControl
                  sx={{
                    m: 1,
                    minWidth: 260,
                    marginBottom: "20px",
                    width: "100%",
                  }}
                >
                  <InputLabel>Day</InputLabel>
                  <Select
                    label="Day"
                    error={errors.day}
                    helperText={errors.day?.message}
                    {...register("day")}
                  >
                    <MenuItem value={"Monday"}>Monday</MenuItem>
                    <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                    <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                    <MenuItem value={"Thursday"}>Thursday</MenuItem>
                    <MenuItem value={"Friday"}>Friday </MenuItem>
                    <MenuItem value={"Saturday"}>Saturday</MenuItem>
                    <MenuItem value={"Sunday"}>Sunday</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={8}>
                <TimeInput
                  label="Start Time"
                  name="startTime"
                  control={control}
                />
              </Grid>

              <Grid item xs={8}>
                <TimeInput label="End Time" name="endTime" control={control} />
              </Grid>
              <Grid item xs={8}>
                <Controller
                  control={control}
                  name={`timeSlotDurationMins`}
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      options={minutesList}
                      onChange={(_, val) => {
                        onChange(val?.timeSlotDurationMins);
                      }}
                      getOptionLabel={(option) =>
                        option.timeSlotDurationMins || option
                      }
                      renderInput={(params) => (
                        <TextField
                          label="Time Slot Duration (in minutes)"
                          {...params}
                          error={Boolean(error)}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.id}>
                            {option.timeSlotDurationMins}
                          </li>
                        );
                      }}
                      sx={{ width: "95%", paddingBottom: "15px" }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddDailySchedule}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddDailyScheduleDialog;
